export { default } from "./billingUpdatesPageNotificationCard";
export type { NotificationProps } from "./billingUpdatesPageNotificationCard";
